/** @jsx jsx */

import React, { useEffect, useRef } from "react";
import Modal from '@material-ui/core/Modal';
import { jsx, css } from "@emotion/react";
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import UploaderVideoPreview from "../Preview/UploaderVideoPreview";

const theme = createTheme({
    overrides: {
        MuiButton: {
            sizeLarge: {
                "& $label": {
                    font: "normal normal 700 1.25rem/1.875rem Open Sans",
                }
            }
        }
    }
});

const btnDiv = css`
    float: right;
    padding-top: 2em;
    padding-bottom: 0.5em;
`;

function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: "2em",
    },
}));

type OldVideoCheckerModalProps = {
    isModalOpen: boolean,
    clickHandler: (e: any) => void;
    uploadedvideoSrc: string;
    videoType: string;
}

const OldVideoCheckerModal: React.FC<OldVideoCheckerModalProps> = (props) => {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);
    const title = "ファイルプレビュー";

    const handleClose = (e: any) => {
        console.log("handleClose");
        props.clickHandler(e);
    };

    const onModalClose = () => {
        console.log("onModalClose");
    }

    useEffect(() => {

    });

    return (
        <div>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={props.isModalOpen}
                onClose={onModalClose}
            >
                <div style={modalStyle} className={classes.paper}>
                    <UploaderVideoPreview title={title} videoSrc={props.uploadedvideoSrc} videoType={props.videoType} ></UploaderVideoPreview>
                    <ThemeProvider theme={theme}>
                        <div css={btnDiv}>
                            <Button size="large" variant="contained" color="primary" onClick={handleClose}>閉じる</Button>
                        </div>
                    </ThemeProvider>
                </div>
            </Modal>
        </div>
    );
};

export default OldVideoCheckerModal;

